export class ChannelUser {
    public ChannelId!: string;
    public PhoneNumber!: string;
}
